import serviceHeaderImage from '@/../../public/storage/images/service-banner.webp';
import Banner from '@/components/Banner';
import { RevealGroup, RevealItem } from '@/components/Reveal';
import ServiceCard from '@/components/ServiceCard';
import ShareDialog from '@/components/ShareDialog';
import Typography from '@/components/ui/typography';
import Band from '@/Layouts/Band';
import SectionLayout from '@/Layouts/SectionLayout';

interface Services {
  title: string;
  slug: string;
  summary: string;
  image_url: string;
  rating_count: number;
  review_count: number;
}

const Index = ({ services }: { services: Services[] }) => {
  return (
    <>
      <Banner
        image={serviceHeaderImage}
        width={1600}
        height={900}
        alt="Service Offerings"
        tagline="Beyond expectations always"
        title="Professional Services from Samuthrika Academy"
        description="In addition to education and skill development, Samuthrika
              Academy provides selected professional services through its service
              ecosystem. Explore the available services, understand what is
              included and contact us for current availability, pricing and
              appointments."
      >
        <ShareDialog
          url={window.location.href}
          title={'Professional Services - ' + import.meta.env.VITE_APP_NAME}
          content="In addition to education and skill development, Samuthrika Academy provides selected professional services through its service ecosystem. Explore the available services, understand what is included and contact us for current availability, pricing and appointments."
        />
      </Banner>

      <Band tone="surface">
        <SectionLayout space="lg">
          {/* Visually hidden: the Banner above already shows this page's h1,
              but nothing else sits between it and the service grid below, so
              screen readers and heading-order checks see a raw h1 -> h3 jump
              without a real h2 to land on. */}
          <Typography.H2 className="sr-only">Our services</Typography.H2>
          <RevealGroup className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {services.map((service) => (
              <RevealItem key={service.slug} className="flex">
                <ServiceCard service={service} />
              </RevealItem>
            ))}
          </RevealGroup>
        </SectionLayout>
      </Band>
    </>
  );
};

export default Index;
